import { useTranslation } from "@opendash/i18n";
import { CustomParseFieldProps } from "@opendash/plugin-parse";
import { Button, Popover } from "antd";
import React from "react";
import SimpleMdeReact from "react-simplemde-editor";
import ReadOnlyEditor from "./ReadOnlyEditor";

const ContentField = (props: CustomParseFieldProps<any>) => {
  const t = useTranslation();
  return (
    <>
      {props.setValue ? (
        <SimpleMdeReact value={props.value} onChange={props.setValue} />
      ) : (
        <Popover
          content={<ReadOnlyEditor value={props.value} />}
          trigger={"click"}
        >
          <Button> {t("documentation:admin.docu.content")}</Button>
        </Popover>
      )}
    </>
  );
};

export default ContentField;
